import { render, staticRenderFns } from "./MenuWrapper.vue?vue&type=template&id=4449799b&scoped=true"
import script from "./MenuWrapper.vue?vue&type=script&lang=js"
export * from "./MenuWrapper.vue?vue&type=script&lang=js"
import style0 from "./MenuWrapper.vue?vue&type=style&index=0&id=4449799b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4449799b",
  null
  
)

export default component.exports